import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { SiteProvider } from "./context/SiteContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Collection from "./pages/Collection";
import HowItWorks from "./pages/HowItWorks";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";

const ScrollManager = ({ lenisRef }) => {
  const location = useLocation();
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el && lenisRef.current) {
          lenisRef.current.scrollTo(el, { offset: -90, duration: 1.2 });
        }
      }, 350);
    } else if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    }
  }, [location, lenisRef]);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -16 }}
        transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/behandelingen" element={<Services />} />
          <Route path="/collectie" element={<Collection />} />
          <Route path="/hoe-het-werkt" element={<HowItWorks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/beheer" element={<Admin />} />
          <Route path="/betaling/geslaagd" element={<PaymentSuccess />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <SiteProvider>
        <BrowserRouter>
          <ScrollManager lenisRef={lenisRef} />
          <Layout>
            <AnimatedRoutes />
          </Layout>
          <Toaster position="bottom-right" toastOptions={{ style: { background: "#1C1A19", color: "#F7F5F0", border: "1px solid rgba(247,245,240,0.15)", borderRadius: 0 } }} />
        </BrowserRouter>
      </SiteProvider>
    </LanguageProvider>
  );
}

export default App;
